export default __webpack_public_path__ + "static/media/highknee.9a1b5b81.jpg";